export default {"src":"/_next/static/media/U.1c10ee4e.svg","height":18,"width":18};